import React, { useState } from "react";
import "../components/Table/Table.css";
import TopLoader from "../components/Loader/TopLoader";
import { useTranslation } from "react-i18next";
import ZingChart from "zingchart-react";
import CalendarMap from "../components/Calendar/CalendarMap";
import { Button, TextField } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "../components/Table/Table.css";

const Attendance = ({ userData }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const [punch, setPunch] = useState(false);
  const [selectDate, setSelectDate] = useState("");

  const handlePunch = () => {
    setPunch(!punch);
  };

  // var yearChart = {
  //   type: "calendar",
  //   plot: {
  //     valueBox: {
  //       fontColor: "white",
  //       fontFamily: "Courier New",
  //       fontSize: 12,
  //       fontWeight: "bold",
  //     },
  //     cell: {
  //       margin: 5,
  //     },
  //   },
  //   options: {
  //     year: {
  //       text: "2024",
  //     },
  //     values: [
  //       ["2024-05-31", 0],
  //       ["2024-06-01", 3],
  //     ],
  //   },
  //   plotarea: {
  //     marginTop: "25%",
  //     marginBottom: "0%",
  //   },
  // };
  const handleSelectDateChange = (event) => {
    setSelectDate(event.target.value);
  };

  const dummyData = [
    { id: 1, ID: "12", school_name: "bagamunda", role: "Teacher", department: "Teaching", date: "3-jun-2024", Mode: "WFO", punch_in: "09:00", punch_out: "18:00", work: "9hrs" },
    { id: 2, ID: "123", school_name: "bagamunda", role: "Teacher", department: "Teaching", date: "3-jun-2024", Mode: "WFO", punch_in: "09:00", punch_out: "18:00", work: "9hrs" },
    { id: 3, ID: "1234", school_name: "bagamunda", role: "Teacher", department: "Teaching", date: "3-jun-2024", Mode: "WFO", punch_in: "09:00", punch_out: "18:00", work: "9hrs" },
    { id: 4, ID: "12345", school_name: "bagamunda", role: "Teacher", department: "Teaching", date: "3-jun-2024", Mode: "WFO", punch_in: "09:00", punch_out: "18:00", work: "9hrs" },
    { id: 5, ID: "123456", school_name: "bagamunda", role: "Teacher", department: "Teaching", date: "3-jun-2024", Mode: "WFO", punch_in: "09:00", punch_out: "18:00", work: "9hrs" },
  ];

  return (
    <div className="p-4">
      <TopLoader loading={isLoading ? "50" : "100"} />
      <h5 className="">{t("Attendance")}</h5>
      <div className="row col-12 d-flex justify-content-center mt-3 p-4">
        <div className="bg-white d-flex row p-4 rounded col-12">
          <p className="fw-bold fs-5 px-0">{t("Today's Attendance")}</p>
          <div className="col-12 d-flex row">
            <div className="col-5 bg-white px-0 p-3 mt-3">
              <h6 className="fw-bold mb-4">Punched In</h6>
              <div className="d-flex col-12">
                <p className="ms-6 fw-bold col-3">Date: </p>
                <p className="col-6">03/06/2024</p>
              </div>
              <div className="d-flex col-12 mt-2">
                <p className="ms-6 fw-bold col-3">Time: </p>
                <p className="col-6">18:00 HH:MM</p>
              </div>
            </div>
            <div className="col-5 bg-white px-0 p-3 mt-3">
              <h6 className="fw-bold mb-4">Punched Out</h6>
              <div className="d-flex col-12">
                <p className="ms-6 fw-bold col-3">Date: </p>
                <p className="col-6">03/06/2024</p>
              </div>
              <div className="d-flex col-12 mt-2">
                <p className="ms-6 fw-bold col-3">Time: </p>
                <p className="col-6">18:00 HH:MM</p>
              </div>
            </div>
          </div>
          <div className="col-12 d-flex justify-content-end">
            <Button
              variant="contained"
              color={!punch ? "success" : "error"}
              onClick={handlePunch}
            >
              {!punch ? "Punch In" : "Punch Out"}
            </Button>
          </div>
        </div>
        <div
          className="p-4 pb-0 col-12 bg-white rounded mt-5"
          style={{ height: "380px" }}
        >
          <p className="fw-bold fs-5 px-0 mb-4">
            {t("Monthly Attendance Overview")}
          </p>
          {/* <ZingChart data={yearChart} height={200} width="100%" /> */}
          <div style={{ overflowX: "scroll" }}>
            <CalendarMap />
          </div>
        </div>
        <div className="p-4 pb-0 col-12 bg-white rounded mt-4">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <p className="fw-bold fs-5 px-0">{t("Attendance Overview")}</p>
            <div className="d-flex align-items-center">
              <TextField
                label={t("Select Date")}
                type="date"
                onChange={handleSelectDateChange}
                InputLabelProps={{
                  shrink: true,
                }}
                className="me-2"
              />
              <Button variant="contained" id="btn" className="me-2">
                {t("View Attendance")}
              </Button>
              <Button variant="contained" color="success">
                {t("Export in CSV")}
              </Button>
            </div>
          </div>
          <div className="Table mb-4">
            <TableContainer
              // component={Paper}
              // style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
              className="my-4"
            >
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>{t("Sr. No.")}</TableCell>
                    <TableCell align="left">{t("ID")}</TableCell>
                    <TableCell align="left">{t("School Name")}</TableCell>
                    <TableCell align="left">{t("Role")}</TableCell>
                    <TableCell align="left">{t("Department")}</TableCell>
                    <TableCell align="left">{t("Date")}</TableCell>
                    <TableCell align="left">{t("Mode")}</TableCell>
                    <TableCell align="left">{t("Punch In")}</TableCell>
                    <TableCell align="left">{t("Punch Out")}</TableCell>
                    <TableCell align="left">{t("Work Hours")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dummyData.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell>{row.id}</TableCell>
                      <TableCell align="left">{row.ID}</TableCell>
                      <TableCell align="left">{row.school_name}</TableCell>
                      <TableCell align="left">{row.role}</TableCell>
                      <TableCell align="left">{row.department}</TableCell>
                      <TableCell align="left">{row.date}</TableCell>
                      <TableCell align="left">{row.Mode}</TableCell>
                      <TableCell align="left">{row.punch_in}</TableCell>
                      <TableCell align="left">{row.punch_out}</TableCell>
                      <TableCell align="left">{row.work}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Attendance;
